import styled from "styled-components";
import { motion } from "framer-motion";

export const BotaoExport = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  background: ${({ theme }) => theme.accent};
  color: #ffffff;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.accentDeep};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Overlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  /* dvh inclui a barra de URL dinâmica em mobile; vh é fallback */
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
`;

export const Modal = styled(motion.div)`
  width: min(440px, 100%);
  max-height: 100%;
  overflow-y: auto;
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 16px;
  padding: 22px 24px;
  z-index: 201;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  margin: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const ModalTitulo = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.textPrimary};
`;

export const BotaoFechar = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
  }
`;

export const ModalSub = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.textSecondary};
  margin: 0 0 14px;
`;

export const SectionLabel = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.textSecondary};
  font-weight: 600;
  margin: 14px 0 6px;
`;

export const FormatoList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 6px;
  margin-bottom: 6px;
`;

export const FormatoItem = styled.button`
  text-align: left;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1.5px solid
    ${({ theme, $active }) => ($active ? theme.accent : theme.border)};
  background: ${({ theme, $active }) =>
    $active ? theme.accent : theme.surfaceAlt};
  color: ${({ $active, theme }) => ($active ? "#ffffff" : theme.textPrimary)};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition: all 0.15s ease;

  strong {
    font-size: 13px;
    font-weight: 600;
  }
  span {
    font-size: 11px;
    color: ${({ $active, theme }) =>
      $active ? "rgba(255,255,255,0.85)" : theme.textSecondary};
  }

  &:hover {
    border-color: ${({ theme }) => theme.accent};
  }
`;

export const OpcoesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
`;

export const OpcaoItem = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13.5px;
  color: ${({ theme }) => theme.textPrimary};
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  transition: background 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.surface};
    border-color: ${({ theme }) => theme.accent};
  }

  small {
    margin-left: auto;
    color: ${({ theme }) => theme.textSecondary};
    font-size: 11px;
  }
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 6px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, $active }) => ($active ? theme.accent : theme.surface)};
  border: 1.5px solid
    ${({ theme, $active }) => ($active ? theme.accent : theme.border)};
  color: #ffffff;
  transition: all 0.15s ease;
`;

export const Toggle = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
`;

export const ToggleSwitch = styled.span`
  width: 36px;
  height: 20px;
  background: ${({ theme, $on }) => ($on ? theme.accent : theme.border)};
  border-radius: 999px;
  position: relative;
  transition: background 0.18s ease;
  flex-shrink: 0;

  &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: ${({ $on }) => ($on ? "18px" : "2px")};
    width: 16px;
    height: 16px;
    background: #ffffff;
    border-radius: 50%;
    transition: left 0.18s ease;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-top: 16px;
`;

export const BotaoCancelar = styled.button`
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  background: none;
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.textSecondary};
  }
`;

export const BotaoGerar = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  background: ${({ theme }) => theme.accent};
  color: #ffffff;
  border: 1px solid ${({ theme }) => theme.accent};
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.accentDeep};
    border-color: ${({ theme }) => theme.accentDeep};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErroBox = styled.div`
  margin: 12px 0 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.dangerSurface};
  border: 1px solid ${({ theme }) => theme.dangerBorder};
  color: ${({ theme }) => theme.dangerText};
  font-size: 12px;
`;

/* Aviso não-bloqueante (ex.: todas as seções selecionadas sem linhas). */
export const AvisoBox = styled.div`
  margin: 12px 0 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${({ theme }) => theme.warningSurface};
  border: 1px solid ${({ theme }) => theme.warningBorder};
  color: ${({ theme }) => theme.warningText};
  font-size: 12px;
`;
